import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import { templateApi, Template } from "@/api/template";

export interface TemplateState {
  templates: Template[];
}

const templateModule: Module<TemplateState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      templates: [] as Template[],
    } as TemplateState),
  mutations: {
    setTemplates(state: TemplateState, templates: Template[]): void {
      state.templates = templates.sort((a, b) =>
        a.title.localeCompare(b.title)
      );
    },
  },
  actions: {
    async listAll(
      context: ActionContext<TemplateState, RootState>
    ): Promise<void> {
      if (!context.state.templates || context.state.templates.length === 0) {
        context.commit("setTemplates", await templateApi.listTemplates());
      }
    },
    async addTemplate(
      context: ActionContext<TemplateState, RootState>,
      template: Template
    ): Promise<void> {
      await templateApi.addTemplate(template);
      context.commit("setTemplates", await templateApi.listTemplates());
    },
    async editTemplate(
      context: ActionContext<TemplateState, RootState>,
      template: Template
    ): Promise<void> {
      if (template.id) {
        await templateApi.editTemplate(template);
        context.commit("setTemplates", await templateApi.listTemplates());
      }
    },
    async removeTemplate(
      context: ActionContext<TemplateState, RootState>,
      template: Template
    ): Promise<void> {
      if (template.id) {
        await templateApi.deleteTemplate(template);
        context.commit("setTemplates", await templateApi.listTemplates());
      }
    },
  },
};

export default templateModule;
